import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";

const DefaultRight = () => (
  <div className="flex items-center gap-2">
    <Link to="/katalog" data-testid="shop-cart-btn" aria-label="keranjang" className="w-10 h-10 rounded-full border border-slate-200 bg-white grid place-items-center hover:bg-slate-50 transition-colors"><ShoppingCart className="w-5 h-5" /></Link>
    <Link to="/katalog" data-testid="nav-customer-login" className="bg-slate-900 text-white text-sm px-4 py-2 rounded-lg hover:bg-slate-800 transition-colors">Log in</Link>
  </div>
);

export function PublicNav({ right }) {
  return (
    <>
    <header className="sticky top-0 z-40 backdrop-blur bg-white/80 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logo-fomu.webp" alt="FOMU 3D PRINT" className="h-9 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
          <Link to="/katalog" data-testid="nav-katalog" className="hover:text-slate-900 transition-colors">Katalog</Link>
          <Link to="/calculator" data-testid="nav-calculator" className="hover:text-slate-900 transition-colors">Kalkulator Harga</Link>
          <Link to="/booking" data-testid="nav-booking" className="hover:text-slate-900 transition-colors">Booking Konsultasi</Link>
          <a href="#services" className="hover:text-slate-900 transition-colors">Layanan</a>
        </nav>
        <Link to="/katalog" data-testid="nav-katalog-mobile" className="md:hidden ml-auto mr-3 text-sm text-slate-700 font-medium">Katalog</Link>
        {right || <DefaultRight />}
      </div>
    </header>
    <Link to="/login" data-testid="nav-login" title="Khusus tim FOMU" className="fixed bottom-4 right-4 z-40 text-[11px] px-3 py-1.5 rounded-full bg-white/90 border border-slate-200 text-slate-500 shadow-sm hover:text-slate-900 transition-colors">Login Tim FOMU</Link>
    </>
  );
}

export function PublicFooter() {
  return (
    <footer className="bg-slate-900 text-slate-400 mt-20">
      <div className="max-w-7xl mx-auto px-5 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <img src="/logo-fomu-white.png" alt="FOMU 3D PRINT" className="h-8 w-auto" />
          <p className="text-sm mt-3 max-w-xs">All-in-one 3D Printing: booking, design, produksi, finishing, project & event dalam satu sistem.</p>
        </div>
        <div className="text-sm">
          <div className="text-white font-medium mb-3">Layanan</div>
          <ul className="space-y-2">
            <li>FDM & Resin 3D Printing</li><li>Design & 3D Modeling</li>
            <li>Finishing & Assembly</li><li>Event & Field Project</li>
          </ul>
        </div>
        <div className="text-sm">
          <div className="text-white font-medium mb-3">Mulai</div>
          <ul className="space-y-2">
            <li><Link to="/katalog" className="hover:text-white">Katalog Produk</Link></li>
            <li><Link to="/calculator" className="hover:text-white">Hitung Estimasi</Link></li>
            <li><Link to="/booking" className="hover:text-white">Jadwalkan Kunjungan</Link></li>
            <li><Link to="/login" className="hover:text-white">Workspace Tim</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© 2026 FOMU 3D Printing ERP · Premium Industrial Technology</div>
    </footer>
  );
}
